const ogImageFiles = import.meta.glob('@/assets/images/opengraph/*.png',{eager: true,})

export default ogImageFiles
